import { browserSupportsWebAuthn } from "@simplewebauthn/browser";

/**
 * Returns true if the current browser supports the WebAuthn API.
 * Use this to conditionally render passkey UI elements.
 */
export const isWebAuthnSupported = () => {
  return browserSupportsWebAuthn();
};